import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const RecycleIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M6.17651 2.41522C6.95681 1.01706 9.01151 1.01482 9.79501 2.41127L10.997 4.55354L11.4779 4.24048C11.6685 4.11644 11.9154 4.1115 12.111 4.22781C12.3066 4.34413 12.4154 4.56063 12.3901 4.78292L12.0949 7.37193C12.0748 7.5483 11.9724 7.70573 11.8176 7.79857C11.6627 7.89141 11.4727 7.90926 11.3025 7.84695L8.94618 6.98392C8.73918 6.9081 8.59307 6.72548 8.5678 6.51098C8.54254 6.29647 8.64236 6.08622 8.82633 5.96648L9.52086 5.51438L8.24517 3.2407C8.13324 3.0412 7.83971 3.04153 7.72824 3.24126L6.25747 5.87664L4.67432 5.1069L6.17651 2.41522Z"
		/>
		<path
			fill="currentColor"
			d="M3.77525 10.3244L4.44834 10.6883C4.6423 10.7931 4.88011 10.7828 5.06373 10.6615C5.24734 10.5401 5.34567 10.3284 5.31818 10.1135L5.02363 7.81219C5.00125 7.63731 4.89803 7.4821 4.74355 7.39101C4.58907 7.29993 4.40036 7.28302 4.23148 7.34513L1.87336 8.21241C1.65841 8.29146 1.51011 8.48532 1.49343 8.70904C1.47675 8.93277 1.59472 9.14556 1.79567 9.2542L2.22902 9.48847L1.25437 11.2349C0.505495 12.5768 1.49996 14.2123 3.06472 14.2123H4.4375V12.4863H3.06472C2.84119 12.4863 2.69912 12.2526 2.8061 12.0609L3.77525 10.3244Z"
		/>
		<path
			fill="currentColor"
			d="M9.15231 14.2123H12.9353C14.5021 14.2123 15.4963 12.5729 14.7434 11.231L13.3892 8.81725L11.8795 9.71822L13.1936 12.0604C13.3011 12.2521 13.1591 12.4863 12.9353 12.4863H9.15253L9.1526 11.9128C9.15263 11.6896 9.02045 11.4865 8.8135 11.3918C8.60654 11.2971 8.36216 11.3278 8.18654 11.4707L6.41819 12.9089C6.28382 13.0182 6.2061 13.1802 6.20607 13.3509C6.20604 13.5217 6.2837 13.6837 6.41803 13.793L8.18602 15.232C8.36161 15.3749 8.60599 15.4057 8.81298 15.311C9.01998 15.2164 9.15221 15.0133 9.15224 14.7901L9.15231 14.2123Z"
		/>
	</svg>
))
